/** @module csi/table/ToolbarBatchFilter */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"lodash",
	"csi/def/Action",
	"csi/html",
	"csi/toolbar/BatchFilter",
	"csi/view/ToolbarPlugin",
	"./ToolbarFilterMixin",
], function(declare, lang, _, Action, html, BatchFilter, ToolbarPlugin, ToolbarFilterMixin) {

	// This module is toolbar plugin which implements table Batch Filter toggle button which toggle Batch Filter container visibility on/off
	// see csi/toolbar/BatchFilter for Batch Filter code

	return declare([BatchFilter, ToolbarPlugin, ToolbarFilterMixin], {
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {m_id: "ViewQuery"});
		},

		canShowPlugin: function() {
			var view = this.getView();
			// hide batch filter
			if (view.disableBatchFilter) {
				return false;
			}
			// hide batch filter and batch filter container if table is empty prior to filtering
			const isEmptyTable = !view.hasResultRows() && !view._hasColumnFilter() && !view.isSuspended();
			const canShow = !view.disableAdHoc && !isEmptyTable;
			html.setVisible(this.filterContainer.domNode, canShow);
			return canShow;
		},

		/**
		 * Associate BatchFilter with view toolbar
		 */
		postCreate: function() {
			this.set("queryMixin", this.getView());
			this.createFilterContainer(this.actionToolbar.domNode);
			this.inherited(arguments);
			this.domNode.classList.add("csi-batch-filter");

			var view = this.getView();
			view.watch("disableAdHoc", lang.hitch(this, this._onWatchDisableAdHoc));
			this._onWatchDisableAdHoc(null, null, view.get("disableAdHoc"));
		},

		/**
		 * Do not instantiate plugin when printing or on views that have no data (such as template views)
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint && !!ctx.getContextNode();
		},

		/**
		 * change visibility of batch filter
		 * @param {string} name 
		 * @param {any} oldValue 
		 * @param {any} newValue 
		 */
		_onWatchDisableAdHoc: function(name, oldValue, newValue) {
			const bVisible = !newValue;
			if (oldValue == false) {
				this.filterContainer.onClearFilters();
				this._cleanupFilters();
			}
			html.setVisible(this.filterContainer, bVisible);
		},

		/**
		 * @override
		 * resize view
		 */
		_onClickAction: function(evt) {
			this.inherited(arguments);
			this.queryMixin.resize();
		}

	});
});